import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { TenantFormFieldNames } from '../types/tenantFormFieldNames';
import { TenantGuarantorFormValues } from '../types/tenantGuarantorFormValues';
import { addressValidationRules } from 'features/new-actor/form/validation-rules/addressValidationRules';

export const tenantGuarantorValidationRules: ValidationRules<Exclude<keyof TenantGuarantorFormValues, 'id'>> = {
  [TenantFormFieldNames.LastName]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Le nom doit contenir au moins 2 caractères')
    .max(50, 'Le nom ne doit pas dépasser 50 caractères')
    .matches(/^[a-zA-ZÀ-ÿ\s'-]+$/, 'Le nom ne doit contenir que des lettres'),

  [TenantFormFieldNames.FirstName]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Le prénom doit contenir au moins 2 caractères')
    .max(50, 'Le prénom ne doit pas dépasser 50 caractères')
    .matches(/^[a-zA-ZÀ-ÿ\s'-]+$/, 'Le prénom ne doit contenir que des lettres'),

  [TenantFormFieldNames.BirthDate]: Yup.date()
    .required('Ce champ est requis')
    .max(new Date(Date.now() - 18 * 365 * 24 * 60 * 60 * 1000), 'Le locataire doit être majeur')
    .min(new Date(Date.now() - 120 * 365 * 24 * 60 * 60 * 1000), 'Veuillez saisir une date de naissance valide')
    .typeError('Veuillez saisir une date valide'),

  [TenantFormFieldNames.Phone]: Yup.string()
    .trim()
    .nullable()
    // Champ optionnel : sans excludeEmptyString, la chaîne vide échoue au regex
    // et bloque le formulaire sans erreur visible tant que le champ n'est pas touché.
    .matches(/^(\+33|0)[1-9](\d{8})$/, {
      message: 'Veuillez saisir un numéro de téléphone français valide',
      excludeEmptyString: true,
    }),

  [TenantFormFieldNames.Email]: Yup.string()
    .trim()
    .nullable()
    .email('Veuillez saisir une adresse email valide')
    .max(100, 'L\'adresse email ne doit pas dépasser 100 caractères'),

  [TenantFormFieldNames.Civility]: Yup.string()
    .required('Ce champ est requis')
    .trim(),

  [TenantFormFieldNames.ProfessionalSituation]: Yup.string()
    .required('Ce champ est requis')
    .trim(),

  [TenantFormFieldNames.Incomes]: Yup.array()
    .of(
      Yup.object().shape({
        amount: Yup.number()
          .required('Le montant est requis')
          .positive('Le montant doit être positif')
          .max(1000000, 'Le montant ne peut pas dépasser 1 000 000 €'),
        incomeType: Yup.string()
          .required('Le type de revenu est requis'),
      })
    )
    .min(1, 'Au moins 1 revenu requis'),

  ...addressValidationRules
};
